'use client'

import { useAuthContext } from '@/context/AuthContext'
import { useBIPageView } from '@/context/BISdkContext'
import { useLayoutContext } from '@/context/LayoutContext'
import { usePageScrollSmooth } from '@/hooks/usePageScrollSmooth'
import { redirect } from 'next/navigation'
import { PropsWithChildren } from 'react'

function ProfilePageWrapper({ children }: PropsWithChildren) {
  const { headerHeight } = useLayoutContext()
  const { isSignedIn } = useAuthContext()

  if (!isSignedIn) {
    redirect('/')
  }

  useBIPageView()
  usePageScrollSmooth()

  return (
    <main
      className="mb-40 overflow-x-clip"
      style={{
        marginTop: headerHeight,
      }}
    >
      {children}
    </main>
  )
}

export default ProfilePageWrapper
